import React from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';
import ContentPage from '../components/content/ContentPage';
import { findService, serviceSeoKey } from '../navigation/serviceCatalog';
import { getServiceContent } from '../content/services/resolve';

// WP-3.3 service page, migrated to the Content Platform (Phase 1). The page is now composed from
// content blocks (Hero + Intro + CTA + RelatedContent) resolved via getServiceContent — authored
// content if present, otherwise the factual default that reproduces the prior body exactly. Metadata
// (<Seo>) and structured data (global <JsonLd/> → graphForPath) are unchanged. FAIL-CLOSED: an
// unknown slug still redirects to the /services hub.
export default function ServicePage() {
  const { slug } = useParams();
  const location = useLocation();
  const service = findService(slug);
  if (!service) return <Navigate to="/services" replace />;

  return (
    <ContentPage
      seoKey={serviceSeoKey(service.slug)}
      path={location.pathname}
      blocks={getServiceContent(service.slug)}
      testId={`service-page-${service.slug}`}
    />
  );
}
